module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAA3XAAAN1wFCKJt4AAAAB3RJTUUH4QsHDAwz4bS8UQAAADtJREFUSMdjYBjugBHGqHVw/09Li5oP7GRkYGBgYKK3D0ctHLVw1MJRC0ctHLVw1MJRC0ctHAoWDn8AADXsBDBnOPO9AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/territorio_nucleos.png
// module id = 7JWJ
// module chunks = 0